import React from 'react';
import cx from 'classnames';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { tokens } from '@swiggy-private/dls-web-common/dist/components/tokens';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
import { IconOutLink } from '@/constants/icons/svg';
// styles
import styles from './SsoLogin.module.scss';
const SsoLogin = ({ handleLogin, className }) => {
    return (React.createElement("div", { className: cx(styles.ssoLogin, className) },
        React.createElement(Text, { variant: DlsFontVariants.body_B1_Bold, color: DlsColorTokens.primary, onClick: handleLogin }, "Login via SSO"),
        React.createElement(IconOutLink, { fillColor: tokens.colors.orange1 })));
};
export default SsoLogin;
